import { useQuery } from '@apollo/client'
import { AccountContext } from '@lib/context/AccountContext/AccountContext'
import { GET_USER_ACCOUNT } from '@lib/graphql/havelock/queries/organization'
import { GraphqlApi } from '@mono/packages/graphql/apollo/constants'
import { currentAccountToViewData } from 'models/account'
import { ReactNode, useMemo } from 'react'

const havelockGraphqlContext = {
  api: GraphqlApi.Havelock
}

const AccountProvider = ({ children }: { children: ReactNode }) => {
  const { data, error } = useQuery(GET_USER_ACCOUNT, {
    context: havelockGraphqlContext
  })

  const currentAccount = data?.getCurrentUserAccount
  const account = useMemo(
    () => (currentAccount ? currentAccountToViewData(currentAccount) : null),
    [currentAccount]
  )

  if (error) throw error

  if (!account) return null

  return (
    <AccountContext.Provider value={account}>
      {children}
    </AccountContext.Provider>
  )
}

export default AccountProvider
